import {inject, IReactComponent} from 'mobx-react';
import {ShareScreenPopup} from './ShareScreenPopup';

const mapStoresToProps = (stores: any) => ({
    ctrl: stores.multipartyDashboardStore.shareScreenPopupController,
    translate: stores.multipartyDashboardStore.localizationService.translate.bind(
        stores.multipartyDashboardStore.localizationService
    )
});

export const ShareScreenPopupComponent = inject(mapStoresToProps)(ShareScreenPopup) as IReactComponent;
